<template>
  <v-list-item class="py-1">
    <v-list-item-content>
      <v-list-item-subtitle>{{ $t(`labels.${field}`) }}</v-list-item-subtitle>
      <v-list-item-title v-if="account">{{ value }}</v-list-item-title>
    </v-list-item-content>
    <v-list-item-action v-if="isSet">
      <v-toolbar flat color="transparent">
        <v-spacer></v-spacer>
        <v-tooltip top transition="fade-transition" v-if="!isVerified && !verifying">
          <template v-slot:activator="{ on }">
            <v-btn small icon @click="verify" v-on="on">
              <v-icon small v-text="$vuetify.icons.values.check"></v-icon>
            </v-btn>
          </template>
          <span>{{ $t('labels.verify') }}</span>
        </v-tooltip>
        <v-progress-circular indeterminate size="16" width="2" v-else-if="!isVerified && verifying" />

        <v-tooltip top transition="fade-transition" v-if="!isVerified && !sending">
          <template v-slot:activator="{ on }">
            <v-btn small icon @click="resend" v-on="on">
              <v-icon small v-text="$vuetify.icons.values.reset"></v-icon>
            </v-btn>
          </template>
          <span>{{ $t('labels.resendLinks') }}</span>
        </v-tooltip>
        <v-progress-circular indeterminate size="16" width="2" v-else-if="!isVerified && sending" />

        <v-tooltip top transition="fade-transition" v-if="!isVerified">
          <template v-slot:activator="{ on }">
            <v-btn small icon @click="editAccount" v-on="on">
              <v-icon small class="warning--text">{{ $vuetify.icons.values.statePending }}</v-icon>
            </v-btn>
          </template>
          <span>{{ $t(`labels.${field}`) }} {{ $t('notVerified') }}</span>
        </v-tooltip>

        <v-tooltip top transition="fade-transition" v-else>
          <template v-slot:activator="{ on }">
            <v-icon small class="success--text" v-on="on">{{ $vuetify.icons.values.stateSuccess }}</v-icon>
          </template>
          <span>{{ $t(`labels.${field}`) }} {{ $t('verified') }}</span>
        </v-tooltip>
      </v-toolbar>
    </v-list-item-action>
  </v-list-item>
</template>

<script>
import { parsePhoneNumberFromString } from 'libphonenumber-js'
import VerifyMixin from './VerifyMixin'
export default {
  name: 'VerifiableField',
  mixins: [VerifyMixin],
  props: {
    field: { type: String, required: true },
    account: Object
  },
  computed: {
    value() {
      let v = this.account && this.account[`${this.field}`]
      if (!v) {
        return
      }
      if (this.field === 'phone') {
        let phone = parsePhoneNumberFromString(v)
        return phone.formatNational()
      }
      return v
    },
    isSet() {
      return this.account && this.account[this.field]
    },
    isVerified() {
      return this.account && this.account[`${this.field}_verified`]
    }
  },
  methods: {
    editAccount() {
      this.$router.push({ name: 'editAccount' })
    }
  }
}
</script>

<style scoped lang="scss">
.v-toolbar {
  ::v-deep .v-toolbar__content {
    padding: 0;

    .v-btn--icon {
      margin-right: 0;
      margin-left: 0;
    }
  }
}
</style>

<i18n>
{
  "en": {
    "notVerified": "not verified",
    "verified": "verified"
  },
  "fr": {
    "notVerified": "non-vérifié",
    "verified": "vérifié"
  }
}</i18n>
